import React from "react";

import { Icon, Link, TagNormal } from "components";

export const MapMarker = ({ text, link, size, className, fieldSize }) => {
  const getIcon = () => {
    if (fieldSize) {
      return <span className="field-size">{fieldSize}</span>;
    }
    return <Icon iconName="klim/map-pin" size={size || "l"} className={className} />;
  };

  return (
    <div className="map-marker">
      {link ? (
        <Link to={link} mixpanelText="map-marker">
          {getIcon()}
        </Link>
      ) : (
        getIcon()
      )}
      {text && <TagNormal text={text} color="brown" className="margin-top-350" />}
    </div>
  );
};

export default MapMarker;
